const t = "Tamamlanan adım", e = "Geri dön{buttonName}", n = "{buttonName} adresine devam edin", a = {
  completedStep: t,
  backButton: e,
  nextButton: n
};
export {
  e as backButton,
  t as completedStep,
  a as default,
  n as nextButton
};
